import { useMemo } from 'react'

import { TestPrepGrade } from '~/behavior-tracking/types'
import { useAppSelector } from '~/redux/hooks'
import ROUTES from '~/shared/constants/routes.const'
import { selectFilterData } from '~/tests/slice/testPrep.slice'

/**
 * The grade of the test being taken on `/test/exam`. `undefined` everywhere else, including Test Prep's
 * results, start, settings and history, whose time keeps counting toward the selected grade: a result opened
 * from history carries no grade of its own in the slice, and `filterData` is the last test generated.
 */
export default function useTestPrepGrade(pathname: string): TestPrepGrade | undefined {
  const filterData = useAppSelector(selectFilterData)

  const openTest = pathname === ROUTES.TEST_EXAM ? filterData : null
  const countryCode = openTest?.countryCode
  // `0` is "no grade" to hom-api.
  const grade = openTest?.grade

  // One object per test, not per render: the trackers re-subscribe when it changes.
  return useMemo(() => (countryCode && grade ? { countryCode, grade } : undefined), [countryCode, grade])
}
